import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import { setLocale } from '@factorin/util';
import withDependencies from '@factorin/container.macro';


const initialLanguage = window.localStorage.getItem('language') || 'ru';

const i18nextParameters = {
    supportedLngs: ['ru', 'en'],
    fallbackLng: 'ru',
    lng: initialLanguage,

    debug: process.env.NODE_ENV === 'development',

    ...process.env.NODE_ENV === 'test' && {
        lng: 'cimode',
        initImmediate: false,
        appendNamespaceToCIMode: true,
    },

    interpolation: { escapeValue: false },
    react: { useSuspense: true },
};

export const i18n = withDependencies(translations => {
    i18next
        .use(initReactI18next)
        .init({
            resources: translations,
            ...i18nextParameters,
        }, () => {
            setLocale(i18next.language);
            window.localStorage.setItem('language', initialLanguage);
        });

    i18next.on('languageChanged', lng => {
        window.localStorage.setItem('language', lng);
        setLocale(lng);
    });

    return i18next;
});
